<template>
  <div class="profile">
    <el-row :gutter="15">
      <el-col :xs="24" :sm="12">
        <div class="info-panel">
          <div class="panelheader">
            <div class="title">Personal Information</div>
          </div>
          <div class="data">
            <div class="user-info">
              <el-row :gutter=40>
                <el-col :span=12 class="label"><strong>Username</strong></el-col>
                <el-col :span=12 class="info">{{user.username}}</el-col>
              </el-row>
              <el-row :gutter=40>
                <el-col :span=12 class="label"><strong>Email</strong></el-col>
                <el-col :span=12 class="info">{{user.email}}</el-col>
              </el-row>
              <el-row :gutter=40>
                <el-col :span=12 class="label"><strong>Name</strong></el-col>
                <el-col :span=12 class="info">{{user.name}}</el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <changepassword @success="onSuccess" />
      </el-col>
    </el-row>

  </div>
</template>

<script>
import auth from '../auth';
import requests from '../requests';

import changePassword from './ChangePassForm.vue';

export default {
  name: 'profile',
  data () {
    return {
      pageName: 'Profile',
      user: {
        username: '',
        email:'',
        name:''
      }
    }
  },
  methods: {
    onSuccess(){
      this.$router.push({ path: '/sites' });
    }
  },
  beforeMount(){
    var id = JSON.parse(auth.getProfile()).user_id;
    var header = {headers: auth.getAuthHeader()};
    var uri = auth.getApi();
    this.$http.get(uri + '/api/user', {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
      var profile = result.body.data;
      this.user = profile;
    });

  },
  components: {
    'changepassword': changePassword
  }
}
</script>

<style>
  .profile .password-panel .data, .profile .info-panel .data{
    background-color: white;
    padding: 8pt;
  }
  
  .pass-reset {
    text-align: left;
  }
  
  .pass-reset .el-input__inner {
    width: 80%;
  }
  
  .password-panel .data {
    padding-left: 40pt !important;
    text-align: left;
  }
  
  .user-info {
    width: 60%;
    font-size: 1.2em;
  }
  
  .user-info div {
    padding-bottom: 10pt;
  }
  
  .user-info .label {
    text-align: right;
  }
  
  .user-info .info {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?8a6e4e56